import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

class OrderInfo extends Component {
  render() {
    const dataViewingStrings = strings.dataViewing;
    const { viewType } = this.props;
    const showCurrency = viewType !== 'ord-disp-voice' && viewType !== 'trade-disp';
    let orderInfo = [
      { label: dataViewingStrings.tradingVenue, text: this.props.tradingVenue },
      { label: dataViewingStrings.assetClass, text: this.props.assetClass },
      { label: dataViewingStrings.subAssetClass, text: this.props.subAssetClass },
      { label: dataViewingStrings.instrumentId, text: this.props.instrumentId },
      { label: dataViewingStrings.instrumentDesc, text: this.props.instrumentDesc },
      //{ label: dataViewingStrings.venueType, text: this.props.venueType },
      { label: dataViewingStrings.venueMIC, text: this.props.venueMIC },
      showCurrency ? { label: dataViewingStrings.currency, text: this.props.currency } : null
    ];

    const additionalDescription = this.props.additionalDescription;

    if (additionalDescription) {
      orderInfo.push(
        { label: dataViewingStrings.instrumentIdType, text: additionalDescription.instrumentIdType },
        { label: dataViewingStrings.instrumentId, text: additionalDescription.instrumentId },
        { label: dataViewingStrings.displayDate, text: additionalDescription.displayDate }
      );
    }

    return (
      <div>
        <div className="order-info-caption">
          <p>
            <span>{dataViewingStrings.orderTableCaption.before}</span>
            <b>{dataViewingStrings.orderTableCaption[this.props.dataType]}</b>
            <span>
              {dataViewingStrings.orderTableCaption[this.props.tradeDisplay ? 'trade' : 'order']}
              {dataViewingStrings.orderTableCaption.after}
            </span>
          </p>
        </div>
        <div className="order-info">
          {orderInfo
            .filter(item => item !== null)
            .map(
            (item, index) =>
              item.text != null ? (
                <p key={`order-info-item-${index}`}>
                  {item.label}: <b>{item.text}</b>
                </p>
              ) : null
          )}
        </div>
      </div>
    );
  }
}

export default OrderInfo;



// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/OrderInfo.jsx